import classNames from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class TabPanel extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    isActive: PropTypes.bool,
    onActivate: PropTypes.func,
    onlyRenderOnActive: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired
  }

  static defaultProps = {
    onlyRenderOnActive: false
  }

  constructor(props) {
    super(props)

    this.triggerActivate = this.triggerActivate.bind(this)
  }

  componentDidMount() {
    setTimeout(this.triggerActivate)
  }

  componentDidUpdate(prevProps) {
    this.triggerActivate(prevProps)
  }

  triggerActivate(prevProps = {}) {
    if (this.hasActivated(prevProps) && this.props.onActivate) {
      this.props.onActivate()
    }
  }

  hasActivated(prevProps) {
    return this.props.isActive && this.props.isActive !== prevProps.isActive
  }

  render() {
    const { children, isActive, onlyRenderOnActive } = this.props
    const classes = classNames({
      'is-hidden': !isActive
    })

    if (!isActive && onlyRenderOnActive) {
      return null
    }

    return <article className={classes}>{children}</article>
  }
}



// WEBPACK FOOTER //
// ../src/components/TabPanel.js